import { render, staticRenderFns } from "./douyin.vue?vue&type=template&id=755ee8d9&scoped=true"
import script from "./douyin.vue?vue&type=script&lang=js"
export * from "./douyin.vue?vue&type=script&lang=js"
import style0 from "./douyin.vue?vue&type=style&index=0&id=755ee8d9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ee8d9",
  null
  
)

export default component.exports